import { createSlice } from '@reduxjs/toolkit';

const initialQRCodeState = { data: null };

const qrcodeSlice = createSlice({
  name: 'qrcode',
  initialState: initialQRCodeState,
  reducers: {
    store(state, action) {
      state.data = action.payload;
    },
    reset(state, action){
      state.data = initialQRCodeState;
    }
  }
});

export const qrcodeActions = qrcodeSlice.actions;

export default qrcodeSlice.reducer;